module.exports = __webpack_public_path__ + "img/java-logo.a732a6e5.svg";